<script setup lang="ts">
import { ref } from 'vue'
import { Card, Icon} from '@bagelink/vue'
const logo = ref('/logo-sellameir-white.svg')
</script>

<template>
	<div class="maintenance-page">
		<div class="txt-center">
			<img :src="logo" alt="סלע מאיר" class="logo" />
			<Card class="w-600">
				<Icon name="build_circle" size="2" />
				<h1>האתר בתחזוקה</h1>
				<p class="message">
					אנחנו עובדים על שיפורים באתר
					<br />
					נחזור בקרוב!
				</p>
			</Card>
		</div>
	</div>
</template>

<style scoped>
.maintenance-page {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	direction: rtl;
}

.maintenance-content {
	text-align: center;
	padding: 2rem;
	max-width: 600px;
}

.logo {
	width: 200px;
	height: auto;
	margin-bottom: 3rem;
	filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.message-container {
	background: rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(10px);
	border-radius: 20px;
	padding: 3rem 2rem;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.2);
}


.spinner {
	width: 40px;
	height: 40px;
	margin: 0 auto;
	border: 4px solid rgba(255, 255, 255, 0.3);
	border-top-color: white;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

@media screen and (max-width: 768px) {
	.logo {
		width: 150px;
		margin-bottom: 2rem;
	}

	.message-container {
		padding: 2rem 1.5rem;
	}

}
</style>

